import { Injectable } from '@angular/core'
import { DataService } from '@vendure/admin-ui/core'

import { GetNextAgeStatesDocument, TransitionAgeToStateDocument } from '../generated/ui-types'

@Injectable()
export class AgeStateDataService {
    constructor(private dataService: DataService) {}

    getNextStates(id: string) {
        return this.dataService.query(GetNextAgeStatesDocument, {
            id,
        })
    }

    transitionToState(id: string, state: string) {
        return this.dataService.mutate(TransitionAgeToStateDocument, {
            id,
            state,
        })
    }
}
